import Component from "@lib/Component.js";
import gsap from "gsap";
import { addClass, removeClass, addEvent, removeEvent } from "@qneyraud/q-utils/umd/q-utils";

export default class Input extends Component {
  init() {
    super.init();
    this.bindMethods();

    this.currentSlideIndex = 0;

    this.touchX = null;
  }

  onEnterCompleted() {
    super.onEnterCompleted();

    this.initEvents();

    this.updateButtonsState();
    this.updateIndicators();
  }

  onLeaveCompleted() {
    this.removeEvents();
  }

  bindMethods() {
    this.onPreviousButtonClick = this.onPreviousButtonClick.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.onSliderImageClick = this.onSliderImageClick.bind(this);
    this.onSliderImageTouchStart = this.onSliderImageTouchStart.bind(this);
    this.onSliderImageTouchEnd = this.onSliderImageTouchEnd.bind(this);
    this.onSliderImageTouchMove = this.onSliderImageTouchMove.bind(this);
  }

  initEvents() {
    addEvent(this.refs["nav-previous"], "click", this.onPreviousButtonClick);
    addEvent(this.refs["nav-next"], "click", this.onNextButtonClick);
    addEvent(this.refs["image-slider-image"], "click", this.onSliderImageClick);
    addEvent(this.refs["image-slider-image"], "touchstart", this.onSliderImageTouchStart);
    addEvent(this.refs["image-slider-image"], "touchend", this.onSliderImageTouchEnd);
    addEvent(this.refs["image-slider-image"], "touchmove", this.onSliderImageTouchMove);
  }

  removeEvents() {
    removeEvent(this.refs["nav-previous"], "click");
    removeEvent(this.refs["nav-next"], "click");
    removeEvent(this.refs["image-slider-image"], "click");
    removeEvent(this.refs["image-slider-image"], "touchstart", this.onSliderImageTouchStart);
    removeEvent(this.refs["image-slider-image"], "touchend", this.onSliderImageTouchEnd);
    removeEvent(this.refs["image-slider-image"], "touchmove", this.onSliderImageTouchMove);
  }

  isLastSlide() {
    return this.currentSlideIndex === this.refs["slider-item"].length - 1;
  }

  isFirstSlide() {
    return this.currentSlideIndex === 0;
  }

  goToNextSlide() {
    if (this.isLastSlide()) return;

    this.currentSlideIndex++;
    this.goToCurrentSlide();
  }

  goToPreviousSlide() {
    if (this.isFirstSlide()) return;

    this.currentSlideIndex--;
    this.goToCurrentSlide();
  }

  goToCurrentSlide() {
    const onStart = () => {
      addClass([this.refs["nav-previous"], this.refs["nav-next"]], "animating");
      removeClass(this.refs["slider-item"], "current");
      this.updateButtonsState();
    };

    const onComplete = () => {
      removeClass([this.refs["nav-previous"], this.refs["nav-next"]], "animating");
    };

    gsap
      .timeline({
        onStart,
        onComplete
      })
      // items
      .to(this.refs["slider-item"], {
        duration: 0.9,
        ease: "power2.inOut",
        x: this.currentSlideIndex * -100 + "%"
      })
      // state & nav buttons show
      .call(
        () => {
          addClass(this.refs["slider-item"][this.currentSlideIndex], "current");
        },
        this,
        0.3
      );
    this.updateIndicators();
  }

  updateIndicators() {
    const normalizedProgress = this.currentSlideIndex / (this.refs["slider-item"].length - 1);

    gsap
      .timeline()
      .to(
        this.refs["progress-numeric"],
        {
          duration: 0.9,
          x: normalizedProgress * this.refs["progress"].clientWidth,
          ease: "power2.inOut"
        },
        0
      )
      .to(
        this.refs["progress-bar"],
        {
          duration: 0.9,
          scaleX: normalizedProgress,
          ease: "power2.inOut"
        },
        0
      );

    this.refs["progress-current"].innerText = this.currentSlideIndex + 1;
  }

  updateButtonsState() {
    if (this.isLastSlide()) {
      addClass(this.refs["nav-next"], "disabled");
    } else {
      removeClass(this.refs["nav-next"], "disabled");
    }

    if (this.isFirstSlide()) {
      addClass(this.refs["nav-previous"], "disabled");
    } else {
      removeClass(this.refs["nav-previous"], "disabled");
    }
  }

  onSliderImageClick(e) {
    if (e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.index) {
      const index = parseInt(e.currentTarget.dataset.index);

      if (index === this.currentSlideIndex) return;

      this.currentSlideIndex = index;
      this.goToCurrentSlide();
    }
  }

  onNextButtonClick() {
    this.goToNextSlide();
  }

  onPreviousButtonClick() {
    this.goToPreviousSlide();
  }

  onSliderImageTouchStart(e) {
    this.touchX = e.changedTouches[0].screenX;
  }

  onSliderImageTouchEnd(e) {
    const diff = this.touchX - e.changedTouches[0].screenX;

    if (diff < -80) {
      this.goToPreviousSlide();
    } else if (diff > 80) {
      this.goToNextSlide();
    }
  }

  onSliderImageTouchMove(e) {
    const diff = this.touchX - e.changedTouches[0].screenX;

    if (Math.abs(diff) > 40) {
      e.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/ImageSlider.js